/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import { LogLevel } from "@azure/msal-browser";
import { detectTier } from "../common/tierDetection"
const B2CCONFIG = require('./azure-b2c.json');

const thisTier = detectTier().name;
const loginFlow = B2CCONFIG.USERFLOWS[thisTier] ? B2CCONFIG.USERFLOWS[thisTier].LOGIN : B2CCONFIG.USERFLOWS['*'].LOGIN;
const b2clogin = B2CCONFIG.TENANTHOSTNAME.replace('.onmicrosoft.', '.b2clogin.');

/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */
export const msalConfig = {
    auth: {
        clientId: B2CCONFIG.CLIENTID, // This is the ONLY mandatory field that you need to supply.
        authority: `https://${b2clogin}/${B2CCONFIG.TENANTHOSTNAME}/${loginFlow}`,
        authorityMetadata: '{  "issuer": "https://satmspcustomers.b2clogin.us/73bb33b8-0dee-4e07-8ae7-f0a18cf4872e/v2.0/",  "authorization_endpoint": "https://satmspcustomers.b2clogin.us/satmspcustomers.onmicrosoft.us/oauth2/v2.0/authorize?p=b2c_1_satmsp-sms-mfa",  "token_endpoint": "https://satmspcustomers.b2clogin.us/satmspcustomers.onmicrosoft.us/oauth2/v2.0/token?p=b2c_1_satmsp-sms-mfa",  "end_session_endpoint": "https://satmspcustomers.b2clogin.us/satmspcustomers.onmicrosoft.us/oauth2/v2.0/logout?p=b2c_1_satmsp-sms-mfa",  "jwks_uri": "https://satmspcustomers.b2clogin.us/satmspcustomers.onmicrosoft.us/discovery/v2.0/keys?p=b2c_1_satmsp-sms-mfa",  "response_modes_supported": [    "query",    "fragment",    "form_post"  ],  "response_types_supported": [    "code",    "code id_token",    "code token",    "code id_token token",    "id_token",    "id_token token",    "token",    "token id_token"  ],  "scopes_supported": [    "openid"  ],  "subject_types_supported": [    "pairwise"  ],  "id_token_signing_alg_values_supported": [    "RS256"  ],  "token_endpoint_auth_methods_supported": [    "client_secret_post",    "client_secret_basic"  ],  "claims_supported": [    "idp",    "name",    "emails",    "idp_access_token",    "oid",    "sub",    "newUser",    "tfp",    "isForgotPassword",    "iss",    "iat",    "exp",    "aud",    "acr",    "nonce",    "auth_time"  ]}',
        redirectUri: '/dashboard', // Points to window.location.origin. You must register this URI on Azure Portal/App Registration.
        knownAuthorities: [b2clogin], // Mark your B2C tenant's domain as trusted.
        postLogoutRedirectUri: '/', // Indicates the page to navigate after logout.
        navigateToLoginRequestUrl: false, // If "true", will navigate back to the original request location before processing the auth code response.
    },
    cache: {
        cacheLocation: 'sessionStorage', // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {
        loggerOptions: {
            logLevel: LogLevel.Verbose,
            loggerCallback: (level, message, containsPii) => {
                // console.log(message);
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    case LogLevel.Info:
                        console.info(message);
                        return;
                    case LogLevel.Verbose:
                        console.debug(message);
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        return;
                    default:
                        return;
                }
            },
        },
    },
};

console.log(msalConfig);

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
    scopes: []
};

/**
 * An optional silentRequest object can be used to achieve silent SSO
 * between applications by providing a "login_hint" property.
 */
export const silentRequest = {
    scopes: ["openid", "profile"],
    loginHint: "example@domain.net"
};